import { AppConfig } from '../../app-config'

export const starFilter = [
	{
		name: 'Hotel ratings',
		key: 'hotelRatings',
		options: [
			{
				key: '3_3',
				name: '3 Star',
			},
			{
				key: '4_4',
				name: '4 Star',
			},
			{
				key: '5_4',
				name: '5 Star',
			},
		],
		multiple: true,
	},
]

export const durationFilter = [
	{
		name: 'Number of Days',
		key: 'durations',
		options: [
			{
				key: '3_5',
				name: '3-5 days',
			},
			{
				key: '4_8',
				name: '4-8 days',
			},
			{
				key: '9_12',
				name: '9-12 days',
			},
			{
				key: '13_16',
				name: '13-16 days',
			},
			{
				key: '16_99',
				name: 'Above 16 days',
			},
		],
		multiple: true,
	},
]

export const budgetFilter = [
	{
		name: 'Budget',
		key: 'budgets',
		options: [
			{
				key: '0_50000',
				name: `Below ${AppConfig.rupee_unicode} 50k`,
			},
			{
				key: '50000_75000',
				name: `${AppConfig.rupee_unicode} 50k - ${AppConfig.rupee_unicode} 75k`,
			},
			{
				key: '75000_100000',
				name: `${AppConfig.rupee_unicode} 75k - ${AppConfig.rupee_unicode} 1L`,
			},
			{
				key: '100000_150000',
				name: `${AppConfig.rupee_unicode} 1L - ${AppConfig.rupee_unicode} 1.5L`,
			},
			{
				key: '150000_200000',
				name: `${AppConfig.rupee_unicode} 1.5L - ${AppConfig.rupee_unicode} 2L`,
			},
			{
				key: '200000_300000',
				name: `Above ${AppConfig.rupee_unicode} 2L`,
			},
		],
		multiple: true,
	},
]
